/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ExprCcl } from './ExprCcl';
import {
    ExprCclFromJSON,
    ExprCclFromJSONTyped,
    ExprCclToJSON,
    ExprCclToJSONTyped,
} from './ExprCcl';
import type { PatientCommonExpression } from './PatientCommonExpression';
import {
    PatientCommonExpressionFromJSON,
    PatientCommonExpressionFromJSONTyped,
    PatientCommonExpressionToJSON,
    PatientCommonExpressionToJSONTyped,
} from './PatientCommonExpression';
import type { DocCcl } from './DocCcl';
import {
    DocCclFromJSON,
    DocCclFromJSONTyped,
    DocCclToJSON,
    DocCclToJSONTyped,
} from './DocCcl';
import type { AssessmentExpr } from './AssessmentExpr';
import {
    AssessmentExprFromJSON,
    AssessmentExprFromJSONTyped,
    AssessmentExprToJSON,
    AssessmentExprToJSONTyped,
} from './AssessmentExpr';
import type { SapExpression } from './SapExpression';
import {
    SapExpressionFromJSON,
    SapExpressionFromJSONTyped,
    SapExpressionToJSON,
    SapExpressionToJSONTyped,
} from './SapExpression';
import type { UiIdentifier } from './UiIdentifier';
import {
    UiIdentifierFromJSON,
    UiIdentifierFromJSONTyped,
    UiIdentifierToJSON,
    UiIdentifierToJSONTyped,
} from './UiIdentifier';

/**
 * A conclusion group inside an entry.
 * groupOrder semantics:
 *   -1 → declassified (History / Ecosystem / Monitored)
 *    0 → general group (no header)
 *   >0 → named group with optional assessment expression
 * 
 * @export
 * @interface ConclusionGroupFull
 */
export interface ConclusionGroupFull {
    /**
     * 
     * @type {number}
     * @memberof ConclusionGroupFull
     */
    conclusionGroupId: number;
    /**
     * 
     * @type {string}
     * @memberof ConclusionGroupFull
     */
    relationshipId: string;
    /**
     * 
     * @type {string}
     * @memberof ConclusionGroupFull
     */
    conclusionText?: string;
    /**
     * 
     * @type {number}
     * @memberof ConclusionGroupFull
     */
    groupOrder: number;
    /**
     * 
     * @type {number}
     * @memberof ConclusionGroupFull
     */
    assessmentExpressionId?: number | null;
    /**
     * 
     * @type {UiIdentifier}
     * @memberof ConclusionGroupFull
     */
    id: UiIdentifier;
    /**
     * Alias for conclusionText
     * @type {string}
     * @memberof ConclusionGroupFull
     */
    text: string;
    /**
     * Row position of the group header in the grid
     * @type {number}
     * @memberof ConclusionGroupFull
     */
    row: number;
    /**
     * Computed display title:
     * - groupOrder -1  → "declassified"
     * - groupOrder  0  → "" (no title)
     * - assessmentExpr set → matched term of the assessment expression
     * - otherwise → dominant anatomical root group, or numbered fallback
     * 
     * @type {string}
     * @memberof ConclusionGroupFull
     */
    groupText: string;
    /**
     * True when groupText is derived from an assessment expression
     * @type {boolean}
     * @memberof ConclusionGroupFull
     */
    isAssessment: boolean;
    /**
     * 
     * @type {AssessmentExpr}
     * @memberof ConclusionGroupFull
     */
    assessmentExpr?: AssessmentExpr;
    /**
     * Resolved expressions of type None or ResultDocument
     * @type {Array<ExprCcl>}
     * @memberof ConclusionGroupFull
     */
    resultsArr: Array<ExprCcl>;
    /**
     * Resolved document-CCLs where templateStatus != None
     * @type {Array<DocCcl>}
     * @memberof ConclusionGroupFull
     */
    templateDocArr: Array<DocCcl>;
    /**
     * Bio-prescription expressions (Prescription + Lab)
     * @type {Array<PatientCommonExpression>}
     * @memberof ConclusionGroupFull
     */
    bioPrescrArr: Array<PatientCommonExpression>;
    /**
     * SAP expressions with resolved icon, order and UI id
     * @type {Array<SapExpression>}
     * @memberof ConclusionGroupFull
     */
    sapExprArr: Array<SapExpression>;
}

/**
 * Check if a given object implements the ConclusionGroupFull interface.
 */
export function instanceOfConclusionGroupFull(value: object): value is ConclusionGroupFull {
    if (!('conclusionGroupId' in value) || value['conclusionGroupId'] === undefined) return false;
    if (!('relationshipId' in value) || value['relationshipId'] === undefined) return false;
    if (!('groupOrder' in value) || value['groupOrder'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('text' in value) || value['text'] === undefined) return false;
    if (!('row' in value) || value['row'] === undefined) return false;
    if (!('groupText' in value) || value['groupText'] === undefined) return false;
    if (!('isAssessment' in value) || value['isAssessment'] === undefined) return false;
    if (!('resultsArr' in value) || value['resultsArr'] === undefined) return false;
    if (!('templateDocArr' in value) || value['templateDocArr'] === undefined) return false;
    if (!('bioPrescrArr' in value) || value['bioPrescrArr'] === undefined) return false;
    if (!('sapExprArr' in value) || value['sapExprArr'] === undefined) return false;
    return true;
}

export function ConclusionGroupFullFromJSON(json: any): ConclusionGroupFull {
    return ConclusionGroupFullFromJSONTyped(json, false);
}

export function ConclusionGroupFullFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConclusionGroupFull {
    if (json == null) {
        return json;
    }
    return {
        
        'conclusionGroupId': json['conclusionGroupId'],
        'relationshipId': json['relationshipId'],
        'conclusionText': json['conclusionText'] == null ? undefined : json['conclusionText'],
        'groupOrder': json['groupOrder'],
        'assessmentExpressionId': json['assessmentExpressionId'] == null ? undefined : json['assessmentExpressionId'],
        'id': UiIdentifierFromJSON(json['id']),
        'text': json['text'],
        'row': json['row'],
        'groupText': json['groupText'],
        'isAssessment': json['isAssessment'],
        'assessmentExpr': json['assessmentExpr'] == null ? undefined : AssessmentExprFromJSON(json['assessmentExpr']),
        'resultsArr': ((json['resultsArr'] as Array<any>).map(ExprCclFromJSON)),
        'templateDocArr': ((json['templateDocArr'] as Array<any>).map(DocCclFromJSON)),
        'bioPrescrArr': ((json['bioPrescrArr'] as Array<any>).map(PatientCommonExpressionFromJSON)),
        'sapExprArr': ((json['sapExprArr'] as Array<any>).map(SapExpressionFromJSON)),
    };
}

export function ConclusionGroupFullToJSON(json: any): ConclusionGroupFull {
    return ConclusionGroupFullToJSONTyped(json, false);
}

export function ConclusionGroupFullToJSONTyped(value?: ConclusionGroupFull | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'conclusionGroupId': value['conclusionGroupId'],
        'relationshipId': value['relationshipId'],
        'conclusionText': value['conclusionText'],
        'groupOrder': value['groupOrder'],
        'assessmentExpressionId': value['assessmentExpressionId'],
        'id': UiIdentifierToJSON(value['id']),
        'text': value['text'],
        'row': value['row'],
        'groupText': value['groupText'],
        'isAssessment': value['isAssessment'],
        'assessmentExpr': AssessmentExprToJSON(value['assessmentExpr']),
        'resultsArr': ((value['resultsArr'] as Array<any>).map(ExprCclToJSON)),
        'templateDocArr': ((value['templateDocArr'] as Array<any>).map(DocCclToJSON)),
        'bioPrescrArr': ((value['bioPrescrArr'] as Array<any>).map(PatientCommonExpressionToJSON)),
        'sapExprArr': ((value['sapExprArr'] as Array<any>).map(SapExpressionToJSON)),
    };
}

